import React, { FC } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Navigate, Outlet } from 'react-router-dom';

import Dashboard from 'components/layouts/Dashboard';

import { isLoggedInVar } from 'graphql/cache';

const AuthRequired: FC = () => {
  const isLoggedIn = useReactiveVar(isLoggedInVar);

  return isLoggedIn ? (
    <Dashboard>
      <Outlet />
    </Dashboard>
  ) : (
    <Navigate to="/login" />
  );
};

export default AuthRequired;
